import { useEffect } from "react"; // 1. Import useEffect
import Head from "next/head";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import LoginRegisterLayout from "../login/LoginRegisterLayout";
import LoginFlowLogo from "components/icons/LoginFlowLogo";
import SeamlessAccessCard from "components/seamless-access-card";
import { destroyZephrSession } from "lib/zephr/public-api";
import Button from "components/buttonNew/button";
import { loginSiteTexts } from "lib/fetchers/siteWide/loginSiteTexts";

type PagePropsWithLogo = {
  loginFlowLogoOverwriteUrl?: string | null;
  loginFlowLogoAlt?: string | null;
  loginFlowLogoWidth?: number | null;
  loginFlowLogoHeight?: number | null;
  sitewideOption: Record<string, any>;
};

export async function getServerSideProps() {
  const [loginSiteTextsFetched] = await Promise.all([loginSiteTexts()]);

  return {
    props: {
      sitewideOption: { ...loginSiteTextsFetched },
    },
  };
}

const VerificationFailedPage = ({
  sitewideOption,
  ...props
}: PagePropsWithLogo) => {
  const { loginFlowLogoOverwriteUrl, loginFlowLogoWidth, loginFlowLogoHeight } =
    props;
  // 2. Add the useEffect hook to handle the async logout on render
  useEffect(() => {
    const logoutUser = async () => {
      await destroyZephrSession();
    };

    logoutUser();
  }, []); // <-- Empty dependency array ensures this only runs once on mount

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ErrorBoundary>
        <LoginRegisterLayout
          logo={
            <LoginFlowLogo
              externalSrc={loginFlowLogoOverwriteUrl}
              alt={props.loginFlowLogoAlt ?? undefined}
              width={loginFlowLogoWidth ?? undefined}
              height={loginFlowLogoHeight ?? undefined}
            />
          }
          form={
            <SeamlessAccessCard
              buttons={
                <>
                  <Button
                    href="/members/login"
                    component="link"
                    size="medium"
                    className="text-center"
                  >
                    {sitewideOption.studentsBackToLoginButton}
                  </Button>
                  <Button
                    href="/"
                    buttonType="secondary"
                    component="link"
                    size="medium"
                    className="text-center"
                    colour="black"
                  >
                    {sitewideOption.studentsReturnToHomepageButton}
                  </Button>
                </>
              }
              header={sitewideOption.studentsVerificationFailedHeading}
              text={sitewideOption.studentsVerificationFailedText}
            />
          }
        />
      </ErrorBoundary>
    </>
  );
};

export default VerificationFailedPage;
